import { proxy } from "valtio";

interface IAppConfigStore {
 state: {
  lang: string;
  dir: string;
  dataThemeMode: string;
  dataMenuStyles: string;
  dataNavLayout: string;
  dataHeaderStyles: string;
  dataVerticalStyle: any;
  StylebodyBg: string;
  StyleDarkBg: string;
  toggled: string;
  dataNavStyle: string;
  horStyle: string;
  dataPageStyle: string;
  dataWidth: string;
  dataMenuPosition: string;
  dataHeaderPosition: string;
  loader: string;
  iconOverlay: string;
  colorPrimaryRgb: string;
  colorPrimary: string;
  bodyBg1: string;
  bodyBg2: string;
  darkBg: string;
  inputBorder: string;
  bgImg: string;
  iconText: string;
  body: any
 },
 ThemeChanger: (value: any) => void
}


export const appConfigStore = proxy<IAppConfigStore>({
    state:{
      lang: "en",
      dir: "ltr",
      dataThemeMode: "light",
      dataMenuStyles: "dark",
      dataNavLayout: "vertical",
      dataHeaderStyles: "light",
      dataVerticalStyle: "overlay",
      StylebodyBg: "107 64 64",
      StyleDarkBg: "93 50 50",
      toggled: "",
      dataNavStyle: "",
      horStyle: "",
      dataPageStyle: "regular",
      dataWidth: "fullwidth",
      dataMenuPosition: "fixed",
      dataHeaderPosition: "fixed",
      loader: "disable",
      iconOverlay: "",
      colorPrimaryRgb: "",
    colorPrimary: "",
      bodyBg1: "",
      bodyBg2: "",
      darkBg: "",
      inputBorder: "",
      bgImg: "",
      iconText: "",
      body: {
        class: "",
      },
    },
    ThemeChanger: (value: any) => {
      appConfigStore.state = value;
    }
  });
